import { FC, ReactNode, createContext, useContext } from 'react';

// Default LHS (order-info) page background used when the merchant has not set a
// colorBackground. Hardcoded rather than read from
// `semanticColors.background.secondary` so the un-themed page background is a
// stable, explicit constant (PAA-2711).
export const DEFAULT_PAGE_BACKGROUND = '#f5f6f7';

// The merchant's raw `colorBackground` seed, exposed separately from the
// generated semantic colors (PAA-2711).
//
// `colorBackground` still flows into `generateSemanticColors` (so cards/dividers
// keep their derived shades), but the LHS (order-info) *page* background is
// painted with this raw seed instead of the generator's derived companion shade,
// so it matches the exact merchant colour. When the merchant sets no background,
// `useMerchantBackground` resolves to `DEFAULT_PAGE_BACKGROUND`.
const MerchantBackgroundContext = createContext<string | undefined>(undefined);

export const MerchantBackgroundProvider: FC<{ colorBackground?: string; children: ReactNode }> = ({
  colorBackground,
  children,
}) => <MerchantBackgroundContext.Provider value={colorBackground}>{children}</MerchantBackgroundContext.Provider>;

// The LHS (order-info) page background color: the raw merchant colorBackground
// seed when set, otherwise the default constant. Always returns a color, so
// consumers never need their own fallback.
export const useMerchantBackground = (): string => useContext(MerchantBackgroundContext) ?? DEFAULT_PAGE_BACKGROUND;
